<script setup lang="ts">
import { useSession } from '@/stores/session';
import SignIn from '@/views/SignIn.vue';

const session = useSession();
</script>

<template>
  <SignIn v-if="!session.signedIn" />

  <template v-else>
    <!-- One group now that the portal covers company purchases only: raise a
         request, settle it with an invoice, look back over either. The legacy
         portal's two columns existed to separate those from personal
         reimbursement, and the captions carried that distinction — with nothing
         to contrast against, both would only add noise. Admin stays pinned to
         the far right. -->
    <nav>
      <span class="nav-logo">Griffin Finance</span>

      <div class="nav-center">
        <div class="nav-group">
          <RouterLink to="/requests" class="nav-tab" active-class="active">Purchase Request</RouterLink>
          <RouterLink to="/invoices" class="nav-tab" active-class="active">Invoices</RouterLink>
          <RouterLink to="/review" class="nav-tab" active-class="active">Review</RouterLink>
        </div>
      </div>

      <div v-if="session.isFinance" class="nav-admin-group">
        <RouterLink to="/exports" class="nav-tab nav-admin" active-class="active">Exports</RouterLink>
        <RouterLink v-if="session.isAdmin" to="/admin" class="nav-tab nav-admin" active-class="active">People</RouterLink>
      </div>
    </nav>

    <div class="view">
      <RouterView />
    </div>
  </template>
</template>
